<template>
  <div class="aside">
    <div class="aside__con" :class="isOpen?'open':''">
      <button type="button" class="aside__btn aside__btn--more" @click="openBtns()"></button>
      <button type="button" class="aside__btn aside__btn--share" @click="openShare(true)"></button>
      <button type="button" class="aside__btn aside__btn--youtube" @click="youtubeLink()"></button>
      <button type="button" class="aside__btn aside__btn--twitter" @click="twitterLink()" v-if="locale === 'JP'"></button>
      <button type="button" class="aside__btn aside__btn--purple" @click="purpleLink()"></button>
      <button type="button" class="aside__btn aside__btn--home"  @click="homeLink()"></button>
    </div>
<!--      <div class="aside__share">-->
        <!--      <div class="aside__share-bg" @click="openShare(false)"></div>-->
        <!--      <div class="aside__share-con">-->
        <!--        <button type="button" class="aside__share-btn aside__share-btn&#45;&#45;facebook">facebook</button>-->
        <!--        <button type="button" class="aside__share-btn aside__share-btn&#45;&#45;twitter">twitter</button>-->
        <!--        <button type="button" class="aside__share-btn aside__share-btn&#45;&#45;link">link</button>-->
        <!--        <button class="aside__share-close" @click="openShare(false)">닫기</button>-->
        <!--      </div>-->
      <div id="share" ></div>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapGetters} from 'vuex';
  import promokit from '@/utils/promokit';
  import gsap from "gsap";

    export default {
      name: "Aside",
      data() {
        return {
          isShare:false,
          initMotion:null,
          isOpen:false,
          device: promokit.util.getDevice(),
        };
      },
      computed: {
        ...mapState([
          'isIntro',
          'locale',
          'country'
        ])
      },
      created(){
      },
      methods:{
        ...mapMutations([
          'setIsLayer'
        ]),
        twitterLink(){
          let resultTwitterLink = 'https://twitter.com/LineageW_JP';
          window.open(resultTwitterLink);
        },
        purpleLink(){
          let resultPurpleLink = 'https://ncpurple.com/kr/intro/index?utm_source=web_lw&utm_medium=purplehome_lw&utm_campaign=lw_2nd_pre_register&utm_content=p_logo';
          window.open(resultPurpleLink);
        },
        homeLink(){
          let resultHomeLink;
          if((this.locale == 'KR') || (this.locale == 'HK') || (this.locale == 'TW') || (this.locale == 'JP')){
            resultHomeLink = '/' + this.locale.toLowerCase() + '/index';
          }
          else{
            resultHomeLink = '/sg/index';
          }
          location.href=(resultHomeLink);
        },
        youtubeLink(){
          let resultYoutubeLink;
          if(this.locale === 'KR'){
            resultYoutubeLink = 'https://www.youtube.com/channel/UC8fO3ZAsmI2dMogK5Mojq2g'
          }
          else{
            resultYoutubeLink = 'https://www.youtube.com/channel/UCQcL_ooESP8rvQa8ogtKkvQ'
          }
          window.open(resultYoutubeLink);
        },
        openBtns(){
          this.isOpen = !this.isOpen
          if(this.isOpen){
            gsap.fromTo(this.$el.querySelector('.aside__btn--share'), 0.3, {opacity:0}, {opacity:1})
            gsap.fromTo(this.$el.querySelector('.aside__btn--youtube'), 0.3, {opacity:0}, {opacity:1, delay:0.05})
            gsap.fromTo(this.$el.querySelector('.aside__btn--purple'), 0.3, {opacity:0}, {opacity:1, delay:0.1})
            gsap.fromTo(this.$el.querySelector('.aside__btn--twitter'), 0.3, {opacity:0}, {opacity:1, delay:0.1})
            gsap.fromTo(this.$el.querySelector('.aside__btn--home'), 0.3, {opacity:0}, {opacity:1, delay:0.15})
          }
        },
        openShare(b){
          if(b){
            //this.isShare = true;
            this.$el.querySelector('#share').classList.add('active');
            gsap.from(this.$el.querySelector('.share-dimmed'), 0.3, {autoAlpha:0, ease:'expo.easeOut'})
            this.setIsLayer(true)
            this.$el.querySelector('.share-dimmed').addEventListener('click', ()=>{this.openShare(false)});

          }else{
            //this.isShare = false;
            this.$el.querySelector('.share-dimmed').removeEventListener('click', ()=>{this.openShare(false)});
            this.setIsLayer(false)
          }
        }
      },
      mounted(){

        this.initMotion = new gsap.timeline({paused:true});
        this.initMotion
          .to(this.$el.querySelector('.aside__con'), 0.5, { autoAlpha:1, ease:'expo.easeInOut'})

        window.initShare()
        this.$el.querySelector('.share-close').addEventListener('click', ()=>{
          this.setIsLayer(false)
        })

        this.$watch('isIntro', (val) => {
          if(!val)this.initMotion.play();
        })
      }
    };
</script>

<style lang="scss">
  .aside{
    position:relative;
    z-index: 12;
    &__con{
      @include position($position:absolute, $top:60px, $right:80px, $width:auto, $height:50px);
      opacity: 0;

    }
    &__btn{
      @include position($position:relative, $width:50px, $height:50px);
      margin:0 8px;
      float:left;
      &:before{
        opacity: 0;
        @include position($position:absolute, $top:-25px, $left:-25px, $width:96px, $height:96px);
        @include bg($bg: '../assets/img/icon_ef.png');
        content: '';
        pointer-events: none;
        transition: 0.3s;
      }
      &:after{
        @include position($position:absolute, $top:0px, $left:0px, $width:100%, $height:100%);
        @include bg($bg: '../assets/img/aside_btn.png');
        background-size: 50px auto;
        content: '';
        transition: 0.3s;
      }
      &:hover{
        &:before {
          opacity: 1;
          transition: 0.3s;
        }
      }
      &--more{
        display: none;
      }
      &--share{
        
        &:after{
          background-position-y: -50px;
        }
      }
      &--youtube{
        margin-left: 6px;
        &:after{
          background-position-y: -100px;
        }
      }
      &--purple{
        &:after{
          background-position-y: -150px;
        }
      }
      &--home{
        margin-left: 3px;
        margin-right: 0;
        &:after{
          background-position-y: -200px;
        }
      }
      &--twitter{
        margin-left: 3px;
        margin-right: 0;
        &:after{
          background-position-y: -250px;
        }
      }
    }
    @include bp(tablet){
      &__con{
        @include position($position:absolute, $top:30px, $right:20px, $width:30px, $height:30px);

        width:30px !important;
      }
      &__btn{
        @include position($position:relative, $width:30px, $height:30px);
        margin:0 0 6px 0;
        float:none;
        &:before{
          display: none;
        }
        &:after{
          background-size: 30px auto;
        }
        &--more{
          display: block !important;
        }
        &--share{
          &:after{
            background-position-y: -30px;
          }
        }
        &--youtube{
          &:after{
            background-position-y: -60px;
          }
        }
        &--purple{
          &:after{
            background-position-y: -90px;
          }
        }
        &--home{
          &:after{
            background-position-y: -120px;
          }
        }
        &--twitter{
          &:after{
            background-position-y: -150px;
          }
        }
        &--share,  &--youtube, &--purple, &--home, &--twitter{
          display: none;
          .open &{
            display: block;
           // margin:0 0 5px 0;
          }
        }
      }
    }
  }
  .share{
    @include position($position:fixed, $top:0px, $left:0px, $width:100%, $height:100%);
    display: none;
    &.active{
      display: block;
    }
    &-dimmed{
      @include position($position:absolute, $top:0px, $left:0px, $width:100%, $height:100%);
      background:#000;
      opacity: 0.45;
    }
    &-list{
      @include position($position:absolute, $top:40px, $right:40px, $width:336px, $height:135px);
      @include bg($bg: '../assets/img/share_bg.png');
      padding:40px 9px 40px 0px;
      text-align: center;
      >a{
        position:relative;
        display: inline-block;
        width:63px;
        height:54px;
        @include bg($bg:'../assets/img/btn_share.png', $position:0 0);
        @include hide-text;
        cursor: pointer;
        &:after{
          @include position($position:absolute, $top:0px, $left:0px, $width:100%, $height:100%);
          @include bg($bg:'../assets/img/btn_share.png', $position:0 0);
          background-position-y:-54px ;
          opacity: 0;
          transition: 0.2s;
          content:'';
        }
        &:hover{
          &:after{
            opacity: 1;
            transition: 0.2s;
          }
        }
      }
    }
    &-line{
      background-position-x:0px !important;
      &:after{
        background-position-x:0px !important;
      }
    }
    &-facebook{
      background-position-x:-63px !important;
      &:after{
        background-position-x:-63px !important;
      }
    }
    &-twitter{
      background-position-x:-126px !important;
      &:after{
        background-position-x:-126px !important;
      }
    }
    &-copy{
      background-position-x:-189px !important;
      &:after{
        background-position-x:-189px !important;
      }
    }
    &-close {
      @include hide-text();
      @include position($position: absolute, $top: 15px, $right: 18px, $width: 18px, $height: 18px);
      @include bg($bg: '../assets/img/icon_x.png', $cover: cover);
      opacity: 0.8;
      transition: 0.3s;

      &:hover {
        opacity: 1;
        transition: 0.3s;
      }
    }
    @include bp(tablet){
      &-list{
        right:20px;
        top:20px;
        transform-origin: 100% 0;
        transform: scale(0.75);
      }
    }


  }
</style>
